import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { PurchasedItemDto, ReportType, SellerRemitDto } from 'remarketing-angular-library';
import { SaComponent } from 'smartauction-frontend-micro-library';
import { TranslocoService } from '@jsverse/transloco';
import { takeUntil } from 'rxjs/operators';
import { ReportHeaderType, ReportRole } from '../../enums';
import { ReportContentComponent } from '../report-content/report-content.component';
import { NgClass } from '@angular/common';
import { ReportHeaderComponent } from '../report-header/report-header.component';

@Component({
    selector: 'app-report-preview',
    templateUrl: './report-preview.component.html',
    styleUrls: ['./report-preview.component.scss'],
    imports: [ReportHeaderComponent, NgClass, ReportContentComponent]
})
export class ReportPreviewComponent extends SaComponent implements OnInit {

  @Input() selectedReportType: ReportType;
  @Input() purchasedItemDtos: PurchasedItemDto[];
  @Input() sellerRemitDtos: SellerRemitDto[] = [];
  @Input() scrollPosition: number;
  @Input() backLinkText: string;
  @Input() backLinkRoute: string;
  @Input() reportRole: ReportRole;
  @Input() headerType: ReportHeaderType;
  @Output() selectedReportTypeChange = new EventEmitter<ReportType>();

  reportTypes = ReportType;
  reportHeaderType = ReportHeaderType;

  textNoReportsSelected = '';
  reportList: ReportType[] = [];

  constructor(
    private readonly translocoService: TranslocoService
  ) {
    super();
  }

  ngOnInit() {
    this.getTranslations();
  }

  getTranslations() {
    this.translocoService.selectTranslateObject('reports.reportPreview').pipe(takeUntil(this.destroyed$)).subscribe(translate => {
      this.textNoReportsSelected = translate.textNoReportsSelected;
    });
  }

  isSelectedReportType(preview: string): boolean {
    return this.selectedReportType === preview;
  }

  handleReportTypeChange(reportType: ReportType) {
    this.selectedReportType = reportType;
    this.selectedReportTypeChange.emit(this.selectedReportType);
  }

  handleReportListChanged(reportList: ReportType[]) {
    this.reportList = reportList;
  }

  showTabularView() {
    return this.headerType === this.reportHeaderType.TABULAR ||
      (this.headerType === this.reportHeaderType.DROPDOWN && this.reportList.length > 0);
  }
  
  findSellerRemitData(auctionItemUuid: string) {
    return this.sellerRemitDtos.find(sellerRemitDto => sellerRemitDto.auctionItemUuid === auctionItemUuid) ?? {};
  }
}
